import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { HubFeature } from '@ats/api/cm';
import { CmAuthService } from '@ats/cm/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CmTableService, SELECT_COLUMN_NAME } from '../../services/table.service';

@Component({
	selector: 'cm-table-meta',
	templateUrl: './table-meta.component.html',
	styleUrls: ['./table-meta.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CmTableMetaComponent implements OnInit {
	selectionField = SELECT_COLUMN_NAME;
	filteredColumns$: Observable<string[]>;
	hideExport$: Observable<boolean>;

	constructor(private waiter: CmTableService, private authService: CmAuthService) {
		this.hideExport$ = this.authService.guard$.pipe(
			map(
				guard =>
					guard
						.reset()
						.everyFeature([HubFeature.AwsCustomReportsRemoveDataDownloadButtons])
						.notInternal().all || this.waiter.config.disableExport
			)
		);
	}

	get showSearch() {
		return !this.waiter.config.disableSearch;
	}

	get showSelectedFilter() {
		return !this.waiter.config.disableSelectFilter;
	}

	get isSelectable() {
		return this.waiter.config.selectable;
	}

	ngOnInit(): void {
		this.filteredColumns$ = this.waiter.columns$.pipe(
			map(columns => columns.filter(col => !!col.filter).map(col => col.field))
		);
	}

	exportCSV() {
		const blob = this.waiter.exportAsCSV();
		const url = window.URL.createObjectURL(blob);
		const anchor = document.createElement('a');
		anchor.download = `${this.waiter.config.exportFilename}.csv`;
		anchor.href = url;
		anchor.click();
		anchor.remove();
	}
}
